export default {
    attach: require('./attach-icon/attach-icon.svg'),
    camera: require('./camera-icon/camera-icon.svg'),
};